<template>
    <div class="login-page">
      <div class="login-wrapper">
  
        <!-- LEFT PANEL -->
        <div class="login-left">
          <div class="brand">
            <h1>Angala Farmers</h1>
            <p>Integrated  System</p>
          </div>
  
          <div class="illustration">
            <img src="https://images.unsplash.com/photo-1500937386664-56d1dfef3854" alt="Farm" />
          </div>
  
          <div class="left-footer">
            <p>Empowering Farmers Through Digital Innovation 🌱</p>
          </div>
        </div>
  
        <!-- RIGHT PANEL -->
        <div class="login-right">
          <div class="login-card shadow-lg">
  
            <div class="card-header">
              <h3>Welcome Back 👋</h3>
              <p>Please login to continue</p>
            </div>
  
            <div class="card-body">
  
              <!-- EMAIL -->
              <div class="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Enter email address"
                  v-model="username"
                />
              </div>
  
              <!-- PASSWORD -->
              <div class="form-group">
                <label>Password</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Enter password"
                  v-model="password"
                />
              </div>
  
              <!-- OPTIONS -->
              <div class="form-options">
                <label class="remember">
                  <input type="checkbox" /> Remember me
                </label>
                <a href="#" class="forgot">Forgot Password?</a>
              </div>
  
              <!-- BUTTON -->
              <button
                class="btn-login"
                @click="login()"
                v-if="!loading"
              >
                Login
              </button>
  
              <button class="btn-login loading" disabled v-if="loading">
                <span class="spinner-border spinner-border-sm"></span>
                Please wait...
              </button>
  
            </div>
  
            <div class="card-footer">
              <p>© 2026 Angala Farmers. All rights reserved.</p>
            </div>
  
          </div>
        </div>
  
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VueCountryCode from "vue-country-code";
import swal from 'sweetalert2';

Vue.use(VueCountryCode);

export default {
    
    name: 'SellVendorSigninPage',
    components: {

    },
    
    data() {
    return {
        appTitle: "Angala Farmers",
        
        submit_4: false,
        username: "",
        password: "",
        loading: false,
    };
    },

    beforeMount(){
    document.title = this.appTitle
    },
    mounted() {
    
    },
    created(){
    
    },
    computed: {
    isSubmitButtonDisabled() {
    return (
        this.username === '' ||
        this.password === ''
    );
    }
    },

    methods:{

    async login() {
            try {
                if (!this.username) {
                    alert("Please provide your email address")
                    return;
                }
                const response =  await this.$http.post('/admin/login', {
                      username: this.username,
                      password: this.password
                 })
                if (response.data.success) {
                    await localStorage.setItem("username", this.username)
                    await localStorage.setItem("roles", response.data.data.roles)
                    //console.log(response.data.data)
                    this.$router.push('/home')
                }
                
            } catch (err) {
                this.loading = false
                alert(err.response ? err.response.data.message : err.message)

        }
    },
    
    }
}
</script>
  
<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
  
  * {
    font-family: 'Poppins', sans-serif;
  }
  
  .login-page {
    min-height: 100vh;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1e7d4f, #43b97f);
  }
  
  .login-wrapper {
    width: 100%;
    max-width: 1100px;
    min-height: 600px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  }
  
  /* LEFT */
  .login-left {
    background: linear-gradient(rgba(0,0,0,.4), rgba(0,0,0,.4)),
                url('https://images.unsplash.com/photo-1464226184884-fa280b87c399');
    background-size: cover;
    background-position: center;
    color: #fff;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .brand h1 {
    font-weight: 700;
  }
  
  .brand p {
    opacity: .9;
  }
  
  .illustration img {
    width: 100%;
    border-radius: 12px;
    display: none; /* hidden since bg already used */
  }
  
  .left-footer {
    font-size: 14px;
    opacity: .9;
  }
  
  /* RIGHT */
  .login-right {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background: #f7f9fc;
  }
  
  .login-card {
    width: 100%;
    max-width: 380px;
    background: #fff;
    border-radius: 16px;
    padding: 2rem;
  }
  
  .card-header h3 {
    margin: 0;
    font-weight: 600;
  }
  
  .card-header p {
    font-size: 14px;
    color: #777;
  }
  
  .form-group {
    margin-top: 1.2rem;
  }
  
  .form-group label {
    font-size: 13px;
    font-weight: 500;
  }
  
  .form-control {
    height: 48px;
    border-radius: 10px;
    margin-top: 6px;
    border: 1px solid #ddd;
  }
  
  .form-control:focus {
    border-color: #1e7d4f;
    box-shadow: none;
  }
  
  .form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    font-size: 13px;
  }
  
  .forgot {
    color: #1e7d4f;
    text-decoration: none;
  }
  
  .btn-login {
    width: 100%;
    margin-top: 1.5rem;
    height: 48px;
    border: none;
    border-radius: 10px;
    background: linear-gradient(135deg, #1e7d4f, #43b97f);
    color: #fff;
    font-weight: 600;
    transition: .3s;
  }
  
  .btn-login:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 20px rgba(0,0,0,.15);
  }
  
  .btn-login.loading {
    opacity: .8;
  }
  
  .card-footer {
    text-align: center;
    margin-top: 1.5rem;
    font-size: 12px;
    color: #999;
  }
  
  /* MOBILE */
  @media (max-width: 900px) {
    .login-wrapper {
      grid-template-columns: 1fr;
    }
  
    .login-left {
      display: none;
    }
  }
  </style>
  